module.exports = __webpack_public_path__ + "static/media/hiv-testing-light-orange.4ce10f49.svg";